"use strict";

var _interopRequireDefault = require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.array.concat.js");
require("core-js/modules/es.array.push.js");
require("core-js/modules/es.number.to-fixed.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/web.dom-collections.for-each.js");
var _objectSpread2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/objectSpread2.js"));
var _classCallCheck2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/classCallCheck.js"));
var _createClass2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/createClass.js"));
var _callSuper2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/callSuper.js"));
var _inherits2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/inherits.js"));
var _defineProperty2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/defineProperty.js"));
var _tslib = require("tslib");
var _vuePropertyDecorator = require("vue-property-decorator");
var _ColumnOrderExcelTable = require("./ColumnOrderExcelTable");
var _order = require("@/types/order");
var OrderExcelTable = /*#__PURE__*/function (_Vue) {
  function OrderExcelTable() {
    var _this;
    (0, _classCallCheck2.default)(this, OrderExcelTable);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = (0, _callSuper2.default)(this, OrderExcelTable, [].concat(args));
    (0, _defineProperty2.default)(_this, "data", void 0);
    (0, _defineProperty2.default)(_this, "colsExport", _ColumnOrderExcelTable.colsOrderExcelTable);
    (0, _defineProperty2.default)(_this, "collected", 0);
    (0, _defineProperty2.default)(_this, "notCollected", 0);
    (0, _defineProperty2.default)(_this, "totalCollected", 0);
    return _this;
  }
  (0, _inherits2.default)(OrderExcelTable, _Vue);
  return (0, _createClass2.default)(OrderExcelTable, [{
    key: "generateValue",
    value: function generateValue(item, col, format) {
      // debugger;
      var split = col.split("."),
        a = item;
      split.forEach(function (element) {
        a = a[element] != undefined && a[element] != null ? a[element] : "";
      });
      if (format) {
        return this.$formatDate(a);
      }
      if (typeof a == "boolean") {
        return a ? "Yes" : "No";
      }
      if (col == "orderProgress.deliveryFeeType") {
        return _order.DeliveryFeeTypeTrans[a];
      }
      if (col == "receiverPhone" || col == "customer.phone") {
        return "".concat(a);
      }
      return a;
    }
  }, {
    key: "dataTransform",
    get: function get() {
      var _this2 = this;
      var data = [];
      if (!this.data.length) {
        return;
      }
      // const cols = [];
      // const dataTemp = this.data.length ? this.data[0] : {};
      // Object.keys(dataTemp).forEach((k) => {
      //   if (k == "orderDetails") {
      //     Object.keys(dataTemp[k][0]).forEach((progressKey) => {
      //       cols.push({
      //         label: progressKey,
      //         prop: "item.product" + progressKey,
      //       });
      //     });
      //   }
      // });
      // this.cols = cols;
      // console.log("key ne", JSON.stringify(this.cols));
      var total = {
        quantity: 0,
        price: 0,
        originPrice: 0,
        shipFee: 0,
        vatPrice: 0,
        beforeVatPrice: 0,
        profit: 0,
        returnShipFee: 0
      };
      this.collected = 0;
      this.notCollected = 0;
      this.totalCollected = 0;
      this.data.forEach(function (order) {
        order.orderDetails.forEach(function (e) {
          var tmp = (0, _objectSpread2.default)((0, _objectSpread2.default)({}, order), {}, {
            lotNumber: e.lotNumber,
            isPublished: e.isPublished,
            product: e.product,
            productOriginPrice: e.originPrice,
            productRetailPrice: e.retailPrice,
            productRealPrice: e.realPrice,
            productQuantity: e.quantity,
            productTotalPrice: e.totalPrice,
            productDiscountAmount: e.discountAmount,
            productBeforeVatPrice: e.totalPrice - e.totalPrice * 0.1,
            productVatPrice: e.totalPrice * 0.1,
            productProfit: e.profit,
            productDiscountPercent: +(100 - e.realPrice / e.retailPrice * 100).toFixed(2),
            paymentDeptAmount: order.totalPrice - order.orderProgress.paymentAmount,
            rowspan: 0
          });
          total.quantity += e.quantity;
          total.price += e.totalPrice;
          total.originPrice += e.originPrice;
          total.vatPrice += e.totalPrice * 0.1;
          total.beforeVatPrice += e.totalPrice - e.totalPrice * 0.1;
          total.profit += e.profit;
          total.shipFee += +order.orderProgress.deliveryFee;
          data.push(tmp);
        });
        _this2.notCollected += order.totalPrice - order.orderProgress.paymentAmount;
        _this2.collected += order.orderProgress.paymentAmount;
      });
      this.totalCollected = this.collected + this.notCollected;
      data.push({
        code: "Total",
        productQuantity: total.quantity,
        productOriginPrice: total.originPrice,
        productTotalPrice: total.price,
        productVatPrice: total.vatPrice,
        productBeforeVatPrice: total.beforeVatPrice,
        productProfit: total.profit,
        orderProgress: {
          deliveryFee: total.shipFee
        },
        rowspan: 0
      });
      var count = 0;
      data.forEach(function (element, index) {
        count++;
        if (index < data.length - 1 && element.code != data[index + 1].code) {
          data[index + 1 - count].rowspan = count;
          count = 0;
        }
      });
      data[data.length - count].rowspan = count;
      return data;
    }
  }, {
    key: "dataProduct",
    get: function get() {
      var data = {};
      if (!this.data.length) {
        return [];
      }
      var total = 0;
      this.data.forEach(function (order) {
        order.orderDetails.forEach(function (detail) {
          if (data[detail.product.sku]) {
            data[detail.product.sku] += detail.quantity;
          } else {
            data[detail.product.sku] = detail.quantity;
          }
          total += detail.quantity;
        });
      });
      data["Total"] = total;
      return data;
    }
  }]);
}(_vuePropertyDecorator.Vue);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Prop)()], OrderExcelTable.prototype, "data", void 0);
OrderExcelTable = (0, _tslib.__decorate)([(0, _vuePropertyDecorator.Component)({})], OrderExcelTable);
var _default = exports.default = OrderExcelTable;